export default new Proxy({}, {
  get(_, key) {
    throw new Error(`Module "os" has been externalized for browser compatibility. Cannot access "os.${key}" in client code.  See https://vitejs.dev/guide/troubleshooting.html#module-externalized-for-browser-compatibility for more details.`)
  }
})